import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { buildWhatsappUrl } from "@/lib/whatsapp";
import { trackWhatsappClick } from "@/lib/analytics";

interface WhatsappFabProps {
  /** Optional contextual message override (e.g. on a micro-service page) */
  message?: string;
}

export const WhatsappFab = ({ message }: WhatsappFabProps) => {
  const { t } = useTranslation("whatsapp");
  const finalMessage = message ?? t("default_message");
  const href = buildWhatsappUrl(finalMessage);

  return (
    <a
      href={href}
      onClick={() => trackWhatsappClick({ source: "fab" })}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("floating_label")}
      className="press-scale cta-shine fixed z-50 inline-flex h-14 items-center gap-3 rounded-full bg-success px-10 text-lg font-bold text-success-foreground shadow-warm-lg animate-pulse-warm transition-transform hover:scale-110"
      style={{
        insetInlineEnd: "1rem",
        bottom: "max(1rem, env(safe-area-inset-bottom))",
      }}
    >
      <MessageCircle className="size-6" />
      <span className="hidden text-base font-bold sm:inline">{t("floating_label")}</span>
    </a>
  );
};
